import React from "react";
import { useSelector } from "react-redux";

import MediaSquare from "./MediaSquare/MediaSquare";
import useAdjustStyle from "./useAdjustStyle/useAdjustStyle";

const MediaContainer = ({ luid, elem }) => {
  // window.efs_debug && window.log("MEDIACONTAINER RENDERED");
  const order = useSelector((state) => state.spaceMedia.people[luid].order);
  const visual = useSelector((state) => state.spaceMedia.people[luid].visual);
  const share = useSelector((state) => state.spaceMedia.people[luid].share);

  useAdjustStyle(elem, luid, order, visual, share);

  if (visual) return <MediaSquare luid={luid} visual={visual} order={order} />;
  else return null;
};
export default MediaContainer;
